import React from 'react';
import { footerLinks, socialMedia } from '../constants'
import { logo } from '../assets';

const Footer = () => (
  <section className='flex justify-center items-center sm:py-16 py-6 flex-col'>
    <div className='flex justify-center items-start flex-col md:flex-row w-full mb-8'>

      <div className='flex-1 flex flex-col justify-start mr-10'>
        <img src={ logo } alt="logo" className='w-[266px] h-[72px] object-contain' />
        <p className='font-poppins font-normal text-dimWhite text-[18px] leading-[30.8px] mt-4 max-w-[310px]'>A new way to make the payment easy, reliable and secure.</p>
      </div>

      <div className='flex-[1.5] w-full flex flex-row flex-wrap justify-between md:mt-0 mt-10'>
        {
          footerLinks.map((footerLink) => (
            <div key={ footerLink.title } className='flex flex-col ss:my-0 my-4 min-w-[150px]' >
              <h4 className='font-poppins font-normal text-[18px] leading-[27px] text-white'>{ footerLink.title }</h4>
              <ul className='list-none mt-4'>
                {
                  footerLink.links.map(( link, index ) => (
                    <li key={ link.name } className={`font-poppins font-normal text-[16px] text-dimWhite hover:text-secondary cursor-pointer ${index !== footerLink.links.length - 1 ? 'mb-4' : 'mb-0'}`}>
                      {link.name}
                    </li>
                  ))
                }
              </ul>
            </div>
          ))
        }
      </div>

    </div>

    <div className='flex justify-between items-center flex-col md:flex-row w-full pt-6 border-t-[1px] border-t-[#3f3e45]'>
      <p className='font-poppins font-normal text-center text-[18px] leading-[27px] text-white'>2021 HooBank. All Right Reserved.</p>
      <div className='flex flex-row md:mt-0 mt-6'>
        {
          socialMedia.map(( social, index ) => (
            <img key={ social.id } src={ social.icon } alt={ social.id } className={`w-[21px] h-[21px] object-contain ${index !== socialMedia.length - 1 ? 'mr-6' : 'mr-0'}`} />
          ))
        }
      </div>
    </div>
  </section>
)

export default Footer
